import { WebviewId } from '@gitlab-org/webview-plugin';
import { FastifyInstance } from 'fastify';
import { registerStaticPluginSafely } from '../../http';
import {
  buildWebviewCollectionMetadataRequestHandler,
  buildWebviewRequestHandler,
} from '../handlers';

type SetupWebviewRoutesOptions = {
  webviewIds: WebviewId[];
  getWebviewResourcePath: (webviewId: WebviewId) => string;
};

export const setupWebviewRoutes = async (
  fastify: FastifyInstance,
  { webviewIds, getWebviewResourcePath }: SetupWebviewRoutesOptions,
): Promise<void> => {
  await fastify.register(
    async (instance) => {
      instance.get('/', buildWebviewCollectionMetadataRequestHandler(webviewIds));
      instance.get('/:webviewId', buildWebviewRequestHandler(webviewIds, getWebviewResourcePath));

      // registering static resources across multiple webviews should not be done in parallel since we need to ensure that the fastify instance has been modified by the static files plugin
      for (const webviewId of webviewIds) {
        // eslint-disable-next-line no-await-in-loop
        await registerStaticPluginSafely(instance, {
          root: getWebviewResourcePath(webviewId),
          prefix: `/${webviewId}/`,
        });
      }
    },
    { prefix: '/webview' },
  );
};
